module.exports = __webpack_public_path__ + "img/dot-horizontal.f9942d31.svg";